<template lang="html">
  <div id="scroll" class="scrollable" ref="scrollContainer"

  :class="{
    'caption-active':contentActive>0
    }"
  >
    <!-- <div class="">
      {{stage}}
    </div> -->

    <!-- <div class="scroll-section">
      <div class="absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-full">
        <div class="text-7xl text-red-700 text-center w-full">
          GOSHKA MACUGA
        </div>
      </div>
      <div class="absolute bottom-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2  w-full">
        <div class="text-2xl text-red-700 text-center w-full">
          IN COLLABORATION WITH HATO
        </div>
      </div>
    </div> -->

    <!-- <section class="scroll-section">
      <div class="text-7xl text-red-700 text-center w-full">
      </div>
    </section> -->

    <section class="scroll-section" v-for="content in contents" :key="content.id" :id="`scroll-content-${content.id}`"
    :class="{
      'caption-active':contentActive>0
      }"
    >

      <div class="scroll-target" v-if="content.id==0">

        <!-- <div class="scroll-target-content caption override absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center">
        </div> -->

        <!-- <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full flex justify-center">
          <logo />
        </div> -->

        <!-- <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-2xl md:text-9xl text-red-600 border-2 border-red-600 uppercase px-2 py-2 w-11/12 md:w-auto md:whitespace-nowrap">
          Launch in AR
        </div>-->
        <div class="caption scroll-target-content scroll-to-exlpore override text-xl mx-auto absolute bottom-0 mb-8 left-0 right-0 transform text-center px-8 z-50">
          Scroll to explore
        </div>

      </div>

      <div class="scroll-target" v-if="content.id>0&&content.id<13">
        <div class="caption scroll-target-content readable-caption"
        :class="{
          'current-caption': progress==content.id
          }"
        >
          <div class="text-2xl mb-2 uppercase">
            {{content.title}}
          </div>

          <!-- <transition-group name="fade" mode="out-in"> -->
          <div class="pointer-events-auto cursor-pointer" @click="updateContentActive(content)">
            <VueShowdown :markdown="content.intro" :key="`content-intro-${content.id}`"/>
            <!-- <VueShowdown :markdown="content.intro" v-if="!contentActive" :key="`content-intro-${content.id}`"/> -->
            <!-- <VueShowdown :markdown="content.text" v-if="contentActive" :key="`content-text-${content.id}`"/> -->
          </div>
          <!-- </transition-group> -->

          <div class="pointer-events-auto pointer cursor-pointer mt-2 text-xs uppercase text-red-500 hover:text-red-300" @click="updateContentActive(content)">
            Read more +
          </div>
          <!-- <div class="pointer-events-auto pointer cursor-pointer mt-2 text-xs uppercase text-red-300 hover:text-red-500" v-if="content.intro && !contentActive" @click="updateContentActive(content, true)">
            Read more +
          </div> -->
          <!-- <div class="pointer-events-auto pointer cursor-pointer mt-2 text-xs uppercase text-red-300 hover:text-red-500" v-if="content.intro && contentActive" @click="updateContentActive(content, false)">
            Close ×
          </div> -->

        </div>
      </div>

      <div class="scroll-target scroll-target-ending relative" v-if="content.id==13">
        <!-- <div class="w-full mx-auto max-w-screen-md w-full lg:w-1/2 scroll-target-content absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <div class="pb-3/4 w-full relative">
            <div class="absolute inset-0 pointer-events-auto">
              <iframe
              class="w-full h-full"
              src="https://www.youtube.com/embed/buqtdpuZxvk?enablejsapi=1" width="" height="">
              </iframe>
            </div>
          </div>
        </div> -->
      </div>

    </section>

    <div
    class="caption-wrapper"
    :class="{
      'caption-active':contentActive>0,
      'pointer-events-auto':contentActive>0,
      'pointer-events-none':contentActive<=0
      }"
    >

      <div
      class="fixed sticky-top inset-0 bg-black bg-opacity-80 z-10" @click="updateContentActive()"
      :class="{
        'pointer-events-auto':contentActive>0,
        'opacity-100':contentActive>0,
        'opacity-0':contentActive<=0
        }"
      >
      </div>

      <div class="caption-wrapper-scroller"
      :class="{
        'active':contentActive>0
        }"
      >
        <div class="caption-wrapper-captions relative z-20" v-for="content in contents" :key="content.id" :id="`caption-${content.id}`">
          <div class="caption-wrapper-caption" v-if="content.id > 0 && content.id < 13 && content.id == contentActive">
            <div class="text-2xl mb-4 uppercase">
              {{content.title}}
            </div>
            <VueShowdown :markdown="content.text" v-if="contentActive" :key="`caption-text-${content.id}`"/>
            <div class="caption-wrapper-close pointer-events-auto pointer cursor-pointer mt-2 text-xs uppercase text-red-500 hover:text-red-300 select-none"
            @click="updateContentActive(content, false)">
              <div class="pointer-events-none select-none w-full text-center md:text-left">
                Close ×
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {contents} from '@/common/content.js'
import gsap from 'gsap'

import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

// import logo from '@/components/Intro/logo'

export default {

  data () {
    return {
      contents: contents,
      contentActive: false,
      progress: 0
    }
  },

  // computed: {
  //   contents: ()=> contents
  // },

  components: {
    // logo
  },

  mounted () {
    this.initSingularScrollTrigger()
    this.initScrollTrigger()

    // alert('scroller mounted')
    setTimeout(() => {
      gsap.to(window, {
        duration: 5,
        scrollTo: {
          y:`#scroll-content-1`,
          offsetY: -200
        }
      });
      //scroll to 400 pixels down from the top
      // gsap.to(window, {duration: 2, scrollTo: 400});
    },500)
    // setTimeout(() => {
    //   window.scrollTo({
    //     top: 20,
    //     behavior: 'smooth'
    //   });
    // },500)
  },

  watch: {
    '$route' (newVal, oldVal) {
      if (newVal.path != oldVal.path) {
        this.onRouteChange(newVal)
      }
    }
  },

  methods: {
    onRouteChange (newVal) {
      if (newVal.path=='/') {
        if (window) {
          // window.onscroll = function() {};
          window.document.body.style.overflow = "unset";
          window.document.body.style.pointerEvents = 'auto'
        }
      } else {
        if (window) {
          window.document.body.style.overflow = "hidden";
          window.document.body.style.pointerEvents = 'none'
        }

      }
    },

    updateContentActive (content, contentActive) {
      // content.contentActive = contentActive
      // this.$set(content, 'contentActive', contentActive)
      if (!contentActive) {
        contentActive=this.contentActive>0?false:true
      }
      if (!content) {
        contentActive = false
      }
      this.contentActive = contentActive ? content.id : -1

      if (this.contentActive > 0) {

        // open caption

        gsap.to('.app-header > div', {
          autoAlpha: 0,
          y: '-5px',
          duration: .3
        })
        gsap.to('.readable-caption.current-caption', {
          autoAlpha: 0,
          // y: '-20px',
          duration: .3,
          delay: 0.2
        })

        gsap.fromTo('.caption-wrapper', {
          autoAlpha: 0,
          y: '-5px',
        }, {
          autoAlpha: 1,
          y: 0,
          duration: .3,
          delay: 0.2
        })

        // gsap.set('html, body', {
        //   // overflow: 'hidden'
        // })
        // this.$store.commit('setCaptionState', { active: this.contentActive })
      } else {

        // hide caption

        gsap.to('.app-header > div', {
          autoAlpha: 1,
          y: '0%',
          duration: .5
        })
        gsap.to('.readable-caption.current-caption', {
          autoAlpha: 1,
          // y: '0%',
          duration: .5
        })
        gsap.fromTo('.caption-wrapper', {
          autoAlpha: 1,
          y: 0,
        }, {
          autoAlpha: 0,
          y: '-10px',
          duration: .3,
          delay: 0.2
        })

        gsap.set('html, body', {
          overflow: 'unset'
        })
        // this.$store.commit('setCaptionState', { active: this.contentActive })
      }
      // console.log(content, contentActive)
    },

    initSingularScrollTrigger () {
      let scrollContainer = this.$refs.scrollContainer
      let scroll = ScrollTrigger.create({
        trigger: scrollContainer,
        scrub: 1,
        // markers: true,
        onUpdate: self => {
          // console.log(
          //   "progress:", self.progress.toFixed(3),
          //   "direction:", self.direction,
          //   "velocity", self.getVelocity()
          // );
        },
        end: () => "+=" + scrollContainer.offsetHeight,
      });
    },

    initScrollTrigger () {
      let this_component = this

      this.setScrollProgress(0)

      const scrollTriggerOptions = (index) => {
        return {
          start: 'center center-=0',
          end: 'bottom center-=100',
          pin: true,
          scrub: 0.1,
          markers: false,
          onToggle: self => {
            // console.log("toggled, index isActive:",index, self.isActive)
            if (self.isActive) {
              this.setScrollProgress(index)
            }
          },
          onEnter: self => {
            // console.log("entered index", index)
          },
          onUpdate: self => {
            // console.log(
            //   "progress:", self.progress.toFixed(3),
            //   "direction:", self.direction,
            //   "velocity", self.getVelocity()
            // );
          }
        }
      }

      const sections = gsap.utils.toArray('.scroll-target');
      const sections_contents = gsap.utils.toArray('.scroll-target-content');

      sections.forEach((section, index) => {
        // console.log(section, index, sections_contents[index])

        if (index>0) {
          gsap.set(sections_contents[index], {
            autoAlpha: 0
          })
        }

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            ...scrollTriggerOptions(index)
          }
        })

        tl.to(sections_contents[index], {
          autoAlpha: 1,
          duration: .5,
          // color: 'yellow'
        })

        tl.fromTo(sections_contents[index], {
          y: '+=5%',
        },{
          y: '0%',
          duration: 1,
          // color: 'black',
        })

        // debugger
        // console.log(sections_contents[index])

        if (sections_contents[index] && sections_contents[index].children && sections_contents[index].children[0]) {
          tl.fromTo(sections_contents[index].children[0], {
            autoAlpha: 0,
            y: '+=5%',
          },{
            y: '0%',
            autoAlpha: 1,
            duration: 0.3,
          })
        }
        if (sections_contents[index] && sections_contents[index].children && sections_contents[index].children[1]) {
          tl.fromTo(sections_contents[index].children[1], {
            autoAlpha: 0,
            y: '+=5%',
          },{
            y: '0%',
            autoAlpha: 1,
            duration: 0.3,
          })
        }
        if (sections_contents[index] && sections_contents[index].children && sections_contents[index].children[2]) {
          tl.fromTo(sections_contents[index].children[2], {
            autoAlpha: 0,
            y: '+=5%',
          },{
            y: '0%',
            autoAlpha: 1,
            duration: 0.3,
          })
        }

        tl.to(sections_contents[index], {
          autoAlpha: 0,
          duration: .5,
          delay: 5,
          // color: 'red',
        })

        // gsap.to(section, {
        //   // autoAlpha: 0,
        //   scrollTrigger: {
        //     trigger: section,
        //     ...scrollTriggerOptions
        //   }
        // });

      })

    },

    setScrollProgress (progress) {
      // console.log('setScrollProgress:', progress)
      this.progress = progress
      // for (let i = 0; i < this.contents.length; i++) {
      //   this.updateContentActive(this.contents[i], false)
      // }
      this.$store.commit('setScrollProgress', { progress: progress })
      // this.$store.commit('setStage', { stage: 'LOADED' })
    },
  }
}
</script>

<style lang="scss" scoped>
.scrollable {
  // @apply pointer-events-auto;
  // @apply fixed inset-0 overflow-y-auto pointer-events-auto;
  // @apply border border-red-500
  // @apply relative;
  @apply w-full h-full;
  display: block; border: 10px solid blue;
}
.scroll-section {
  @apply w-full h-full;
  // height: 100vh;
  // @apply border border-blue-500;
  @apply relative;

  @apply mb-48;
  @screen md {
    @apply mb-0;
  }
}
.scroll-target {
  // @apply absolute top-1/2 transform -translate-y-1/2 w-full h-full ;
  @apply w-full h-full ;
  @screen md {
    @apply absolute top-1/2 transform -translate-y-1/2 w-full h-full ;
  }
  // @apply border border-white;
}
.caption {
  &:not(.override) {
    @apply absolute bottom-0 mb-40 left-0 max-w-full px-6 z-20;
    // background: rgba(0,255,0,0.3);
    box-shadow: 0 40px 20px 0px rgba(0,0,0,0.2);
    text-shadow: 0 0 20px #000;
    background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.2));
    @screen md {
      background: none;
      box-shadow: none;
      text-shadow: none;
      @apply absolute top-1/2 left-1/4 transform -translate-x-1/2 -translate-y-1/2 max-w-sm w-full;
    }
  }

  // transition: .5s ease-in-out top, .5s ease-in-out left, .5s ease-in-out transform, .5s ease-in-out max-width, 1s linear box-shadow, 1s linear background;
  transition: 1s linear text-shadow;

  &.content-active {
    // left: 0%;
    // top: 0%;
    // top: 5rem;
    // transform: translate(-0%, -0%) !important;
    z-index: 9999;
    top: 5rem;

    @screen md {
      left: 50%;
      top: 0%;
      top: 5rem;
      transform: translate(-50%, -0%) !important;
      padding: 1rem;
      @apply flex flex-col justify-center;
    }

    max-width: 38rem;
    box-shadow: 0 0px 250px 250px rgba(0,0,0,0.8);
    background: rgba(0,0,0,0.8);
    // text-shadow: 0 0 20px #000, 0 0 50px #000, 0 0 50px #000, 0 0 50px #000, 0 0 50px #000;
  }
}
.caption-wrapper {
  @apply fixed inset-0;
  z-index: 999999;

  .caption-wrapper-scroller {
    @apply fixed inset-0 overflow-y-auto z-10;
    @apply pointer-events-none;
    &.active {
      @apply pointer-events-auto;
      @screen md {
        @apply pointer-events-none;
      }
    }
  }

  .caption-wrapper-captions {
    @screen md {
      @apply absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-screen-sm w-full;
    }
  }
  .caption-wrapper-close {
    @apply fixed bottom-0 left-0 right-0 p-4 pb-8 z-50;
    box-shadow: 0 0px 20px 20px rgba(0,0,0,0.9);
    background: rgba(0,0,0,0.9);
    @screen md {
      @apply relative p-0 mt-4;
      box-shadow: 0 0px 0 0 rgba(0,0,0,0);
      background: rgba(0,0,0,0);
    }
  }
  .caption-wrapper-caption {
    @apply p-4;
    @apply pb-24;
    @screen md {
      @apply pb-3;
    }
  }
}
</style>
